// extracted by mini-css-extract-plugin
export default {"container":"ReservationsListScreen_container__FiWlz","section":"ReservationsListScreen_section__A7eGY","header":"ReservationsListScreen_header__2GRJf"};